<template>
  <span :class="'d-block ' + className">
    <svg>
      <use
        :xlink:href="
          require('@/pages/product_card/assets/img/sprite.svg') +
          `?t=202412051346#${iconName}`
        "
      ></use>
    </svg>
  </span>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Icon",
  props: {
    className: {
      type: String,
      default: "icon-16",
    },
    iconName: {
      type: String,
      default: "",
    },
  },
};
</script>
